import { useTranslations } from '@vocab/react';

import { UpsellPanel } from 'src/app/shared/components/UpsellPanel';
import type { Money, Tax } from 'src/graphql/generated';

import translations from './.vocab';
import upsellImage from './premium-upsell.png';

import * as styles from './index.css';

interface PremiumUpsellProps {
  onButtonClicked: () => void;
  loading?: boolean;
  selected: boolean;
  price?: Money;
  tax?: Tax;
}

export const PremiumUpsell: React.FC<PremiumUpsellProps> = ({
  onButtonClicked,
  loading,
  selected,
  price,
  tax,
}) => {
  const { t } = useTranslations(translations);

  return (
    <UpsellPanel
      price={price}
      tax={tax}
      heading={t('premium-upsell-heading')}
      priceDescription={t('premium-upsell-price-description')}
      benefits={[
        t('premium-upsell-benefits-1'),
        t('premium-upsell-benefits-2'),
      ]}
      image={upsellImage}
      imageClassName={styles.image}
      onClick={onButtonClicked}
      isSelected={selected}
      loading={loading}
    />
  );
};
